var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMmsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65808 30.3996C2.52239 30.3996 1.60156 29.4789 1.60156 28.3432V16.0007C1.60156 12.5983 4.37062 9.82943 7.7733 9.82943C11.176 9.82943 13.945 12.5983 13.945 16.0007V22.172C13.945 23.3054 14.8681 24.2283 16.0016 24.2283C17.1351 24.2283 18.0581 23.3054 18.0581 22.172V18.0571C18.0581 14.6546 20.8271 11.8858 24.2298 11.8858C27.6325 11.8858 30.4016 14.6546 30.4016 18.0571V24.2283C30.4016 25.3639 29.4807 26.2847 28.345 26.2847C27.2094 26.2847 26.2885 25.3639 26.2885 24.2283V18.0571C26.2885 16.9237 25.3655 16.0007 24.232 16.0007C23.0985 16.0007 22.1755 16.9237 22.1755 18.0571V22.172C22.1755 25.5744 19.4064 28.3432 16.0038 28.3432C12.6011 28.3432 9.83201 25.5744 9.83201 22.172V16.0007C9.83201 14.8673 8.90899 13.9443 7.7755 13.9443C6.642 13.9443 5.71898 14.8673 5.71898 16.0007V28.3432C5.71898 29.4789 4.79815 30.3996 3.66246 30.3996H3.65808ZM4.68853 4.68634C4.68853 6.38974 6.06977 7.77307 7.7755 7.77307C9.48122 7.77307 10.8625 6.39194 10.8625 4.68634C10.8625 2.98075 9.47684 1.59961 7.7733 1.59961C6.06977 1.59961 4.68634 2.98075 4.68634 4.68634H4.68853ZM21.1472 6.7427C21.1472 8.4461 22.5285 9.82943 24.2342 9.82943C25.9399 9.82943 27.3212 8.4483 27.3212 6.7427C27.3212 5.03711 25.9399 3.65597 24.2342 3.65597C22.5285 3.65597 21.1472 5.03711 21.1472 6.7427Z",
    fill: "url(#paint0_linear_18068_85375)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18068_85375",
    x1: -1.25301,
    y1: 25.6774,
    x2: 26.9407,
    y2: 8.4135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2035FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1B70FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14BCFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmsLogo);
export default __webpack_public_path__ + "static/media/mms_logo.7b3bec3581a21c576d66295ac2974efd.svg";
export { ForwardRef as ReactComponent };